import Handler from "../Handler";

class WatchTimerHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processWatchTimerHandler(receivedData);
  }
}
export default WatchTimerHandler;

// WatchTimer#
// {
//     "playerName": "aura150000",
//     "tableId": "THR150725-20309401s2yc",
//     "statusCode": "TIME_RUNNING",
//     "timeLeft": 29,
//     "endTime": 1752565861616,
//     "socketClosed": false
// }

// TIME_EXPIRED --> Watch time has expired
// WAITLIST_REJECTED --> Player exited wait list
// WAITLIST_ACCEPTED --> Player joined wait list
// TIME_RUNNING --> Watch timer is running
// TABLE_NOT_FOUND --> Table not found (Same error generic message as next)
// STATE_NOT_FOUND --> State not found (Same error generic message, needn't render for debugging)
// TIMER_REMOVED --> Timer has been removed (State knowledge needn't render)